import { createContext, useCallback, useContext, useEffect, useRef, useState } from "react";
import Dialog from "./Dialog";

const ConfirmContext = createContext(null);
export function ConfirmProvider({ children }) {
  const [request, setRequest] = useState(null);
  const pending = useRef(null);
  const confirm = useCallback((options) => {
    if (pending.current) return Promise.resolve(false);
    return new Promise((resolve) => {
      pending.current = resolve;
      setRequest(typeof options === "string" ? { description: options } : options);
    });
  }, []);
  const finish = (accepted) => {
    const resolve = pending.current;
    pending.current = null;
    setRequest(null);
    resolve?.(accepted);
  };
  useEffect(() => () => { pending.current?.(false); pending.current = null; }, []);
  return <ConfirmContext.Provider value={confirm}>
    {children}
    {request && <Dialog title={request.title || "Confirmer l'action"} onClose={() => finish(false)} size="max-w-lg"
      footer={<>
        <button type="button" data-autofocus className="btn-secondary" onClick={() => finish(false)}>{request.cancelLabel || "Annuler"}</button>
        <button type="button" className={request.danger ? "btn-danger" : "btn-primary"} onClick={() => finish(true)}>{request.confirmLabel || "Confirmer"}</button>
      </>}>
      <p className="whitespace-pre-line text-sm leading-6 text-gray-700">{request.description}</p>
      {!!request.details?.length && <dl className="mt-4 space-y-3 rounded-lg bg-gray-50 p-4 text-sm">
        {request.details.filter(([, value]) => value !== undefined && value !== null && value !== "").map(([label, value]) =>
          <div key={label}><dt className="text-gray-500">{label}</dt><dd className="break-words font-medium text-gray-900">{value}</dd></div>)}
      </dl>}
    </Dialog>}
  </ConfirmContext.Provider>;
}
export function useConfirm() {
  const confirm = useContext(ConfirmContext);
  // Les composants isolés restent utilisables hors de l'application, notamment dans les tests existants.
  return confirm || (async (options) => window.confirm(typeof options === "string" ? options : options.description));
}
export const discardChanges = {
  title: "Quitter sans enregistrer ?",
  description: "Vos modifications ne seront pas enregistrées dans l’application. Vous pouvez revenir à la saisie pour les enregistrer.",
  confirmLabel: "Quitter sans enregistrer",
  cancelLabel: "Continuer la saisie",
  danger: true,
};
